import { getContext } from 'svelte';
import type { FocusManager } from './FocusManager';
import type { FocusParams } from './focus-types';

export const registerFocus = (node: HTMLElement, focusParams: FocusParams) => {
  const focusManager: FocusManager | undefined = getContext('focusManager');

  if (focusManager === undefined) {
    return;
  }

  focusManager.addFocusElementAndSetActiveLayer(node, focusParams.focusName, focusParams.focusLayer);

  const saveFocus = (_focusEvent: FocusEvent) => {
    focusManager.saveFocusedElementName(focusParams.focusName);
  };
  const saveBlur = (focusEvent: FocusEvent) => {
    focusManager.checkIfFocusLeftPlayer(focusEvent);
  };

  node.addEventListener('focus', saveFocus);
  node.addEventListener('blur', saveBlur);

  return {
    destroy: () => {
      focusManager.removeFocusElementAndCheckFocusLost(focusParams.focusName, focusParams.focusLayer);
      node.removeEventListener('focus', saveFocus);
      node.removeEventListener('blur', saveBlur);
    },
  };
};
